import React, { Component } from 'react';
import {  bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setCurrent } from '../actions'
import FontAwesome from 'react-fontawesome'

class Listproject extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expand: false,
      loaded: false,
      hover: false,
      step: 0
    }

  }

  lastStep = 1;

  handleClick(action, link, event) {
    if (action === 'linkTo') {
      window.location.href = link;
      event.stopPropagation();
    } else if (action === 'pushTo') {
      this.props.history.push(`/project/${link}`)
    } else if (action === 'next'){
      this.nextStep();
    }
  }

  nextStep() {
    if (this.state.step === this.lastStep) {
      this.props.history.push(`/project/${this.props.project.path}`)
    } else {
      this.setState({
        step: this.state.step + 1
      })
    }
  }

  render() {
    let {name, about, path, links, mainphoto, bgcolor, mainStill} = this.props.project
    let isOdd = this.props.index % 2;

    let styleLoading = {
      backgroundColor: `rgba(255,255,255,.5)`,
      opacity: '.4'
    }

    let styleLoaded = {
      backgroundColor: bgcolor,
      backgroundImage: this.state.hover ? `url(${mainphoto})`:`url(${mainStill})`,
      alignSelf: isOdd ? 'self-end' : 'flex-start'
    }

    let wrapStyle = {
      backgroundColor: this.state.hover ? bgcolor : this.props.greyBg
    }

    
    let steps = {
      image: {
        class: 'list-proj__photo',
        stepStyle: [{
          top: '12%',
          bottom: '12%'
        },{
          top: '-112%',
          bottom: '112%'
        }]
      },
      desc: {
        class: 'list-proj__desc',
        stepStyle: [{
          top: '100%',
          bottom: '200%'
        },{
          top: '12%',
          bottom: '12%'
        }]
      }
    };

    return (
      <div className="list-proj-wrapper" style={wrapStyle}
        onMouseOver={()=>{ this.setState({hover: true}) }}
        onMouseLeave={()=>{ this.setState({hover: false, step: 0}) }}
        onClick={this.handleClick.bind(this, 'next', null)}>
        <div className={`list-proj ${steps.image.class}`}
          style={Object.assign(this.state.loaded ? styleLoaded : styleLoading, steps.image.stepStyle[this.state.step])} >
        </div>
        <div className={`list-proj ${steps.desc.class}`}
          style={steps.desc.stepStyle[this.state.step]} >
          <h2>{name}</h2>
          <p>{!!this.props.truncate ? about.substring(0, Number(this.props.truncate)) + '... (read more)': about}</p>
          {!!this.props.truncate ? '':<p className="desktop-only">{links.map((link)=> {
              return (
                <span className="link white-hover" title={link.name} onClick={this.handleClick.bind(this, 'linkTo', link.val)}>
                  <FontAwesome name={link.icon} />
                </span>
              )
            })}
            <span className="link white-hover" title="view project" onClick={this.handleClick.bind(this, 'pushTo', path)}>
              <FontAwesome name="plus" />
            </span>
          </p>}
        </div>
        <img src={mainStill}
          onLoad={()=>{ this.setState({ loaded: true }) }}
          style={{display: 'none'}}
          alt="load-test"
          />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    current: state.current,
    projects: state.projects,
    styles: state.styles
  })
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setCurrent
  }, dispatch)
}

const ConnectedListproject = connect(mapStateToProps, mapDispatchToProps)(Listproject)

export default ConnectedListproject



// WEBPACK FOOTER //
// ./src/components/listproject.js